// importing the required chakra libraries
import { extendTheme, type ThemeConfig } from '@chakra-ui/react';

// declare a variable for fonts and set our fonts. I am using Inter with various backups but you can use `Times New Roman`. Note we can set different fonts for the body and heading.
const config: ThemeConfig = {
  initialColorMode: 'dark',
  useSystemColorMode: false,
};

// declare a variable for our theme and pass our overrides in the e`xtendTheme` method from chakra
const theme = extendTheme(config);

// export our theme
export default theme;
